import LineGraph from "../../../../src/components/visualization/LineGraph.tsx";
import archetypesWinrateData from "../../../../src/data/articles/tireless-tracker-analyzing-your-own-cube/archetypes-winrate.json";
import * as React from 'react';
export default {
  LineGraph,
  archetypesWinrateData,
  React
};